module.exports = __webpack_public_path__ + "static/media/hide.e05b2d0f.svg";